import React from 'react';
import { Spin } from "antd";

const Spinner = () => {
    return (
        <div className={"pageLoader"} style={{
            display: "flex", justifyContent: "center",
            alignItems: "center"
        }}>
            <center>
                <Spin size="large" ></Spin>
            </center>
        </div>
    );
}
export default Spinner;